<template>
  <div
    class="d-flex align-items-start justify-content-center match-br-wrapper"
    :data-round-index="roundIndex"
    :data-match-index="matchIndex"
    :dir="isRTL ? 'rtl' : 'ltr'"
  >
    <Panel
      class="position-relative m-2 p-0 w-100 match-card"
      :variant="['input-bg']"
      :class="{
        empty: !match.id,
      }"
    >
      <div class="p-3">
        <Subheader
          class="d-flex justify-content-between w-100 m-0 px-1 pt-2 pb-3 text-truncate"
        >
          {{ roundName }}
        </Subheader>
        <Panel
          v-if="$route.meta.showAdminFunctions"
          :key="`${match.id}-info`"
          :variant="['transparent']"
          class="d-flex align-items-center justify-content-between px-1 py-2 admin-functions"
        >
          <!-- <DateTimePicker
            v-if="match.id && matchStart"
            :id="`${match.id}_${uniqueId}_date`"
            ref="dateInput"
            v-model="matchStart"
            :disabled="!canChangeMatchDate"
            class="date-input--flat cursor-pointer match-date-picker d-flex flex-row align-items-center"
            :class="{ active: canChangeMatchDate }"
            :placeholder="
              $t('_web_tournament_match-date-placeholder', 'Select Date')
            "
            :min-date="prevRoundEnd"
            :max-date="nextRoundStart"
          >
            <Icon
              slot="prepend-date"
              name="calendar"
              width="24"
              :class="{ disabled: !canChangeMatchDate }"
              :fill="$scss.colors.secondaryTextBg"
            />
          </DateTimePicker> -->
          <div class="d-flex align-items-center font-weight-bold mt-3">
            <!-- <Icon
              name="calendar"
              width="16"
              :fill="$scss.colors.secondaryTextBg"
              class="h-mr-3"
            /> -->
            <ToolIcon
              :key="scheduleAction.key"
              :help-text="scheduleAction.title"
              :icon-name="scheduleAction.icon"
              :disabled="scheduleAction.disabled || isEdit"
              variant="circle"
              class="h-mr-3"
              @click="scheduleAction.handler"
            />
            <TextBlock :size="0.75" :variant="'secondary'" :line-height="1"
              >{{
                match.date_start | localDate($times.DATE_SUBMED)
              }},</TextBlock
            >
            <TextBlock
              class="h-ml-3"
              :size="0.75"
              :variant="'secondary'"
              :line-height="1"
              >{{ match.date_start | localDate($times.TIME_SIMPLE) }}</TextBlock
            >
            <TextBlock :variant="'secondary'" :size="0.75" :line-height="1"
              >&nbsp;&ndash;&nbsp;</TextBlock
            >

            <TextBlock :variant="'secondary'" :size="0.75" :line-height="1">{{
              match.date_end | localDate($times.TIME_SIMPLE)
            }}</TextBlock>
          </div>
          <StatusLabel
            :status="match.status"
            class="ml-auto status-label w-100 px-4 py-3"
            :class="{ invisible: !match.status }"
          />
        </Panel>
        <div v-else class="match-start mb-4">
          <Icon
            name="calendar"
            width="16"
            :fill="$scss.colors.secondaryTextBg"
            class="h-mr-3"
          />
          <TextBlock :size="0.75" :variant="'secondary'" :line-height="1">{{
            match.date_start | localDate($times.DATE_MED)
          }}</TextBlock>
          <Icon
            name="time"
            width="16"
            :fill="$scss.colors.secondaryTextBg"
            class="mx-3"
          />
          <TextBlock :size="0.75" :variant="'secondary'" :line-height="1">{{
            match.date_start | localDate($times.TIME_SIMPLE)
          }}</TextBlock>
        </div>
        <div
          v-if="$route.meta.showAdminFunctions"
          class="action-tools d-flex align-items-center justify-content-center my-5"
        >
          <ToolIcon
            v-for="item in filteredMatchAction"
            :key="item.key"
            :help-text="item.title"
            :icon-name="item.icon"
            :disabled="item.disabled || isEdit"
            variant="circle"
            class="h-mr-4"
            @click="item.handler"
          />
        </div>

        <div
          v-if="isEdit"
          class="d-flex justify-content-end p-5 edit-controller-wrapper"
        >
          <Btn
            class="h-ml-4 w-auto btn-secondary-simple flex-shrink-0"
            @click.native="$emit('resetResult')"
          >
            <!--don't change translate-->
            {{ $t('_web_stage_grid_match-edition_cancel', 'Cancel') }}
          </Btn>
          <Btn
            class="h-ml-4 w-auto btn-primary-simple flex-shrink-0"
            :loading="isLoading"
            @click.native="$emit('saveResult')"
          >
            <!--don't change translate-->
            {{ $t('_web_stage_grid_match-edition_save', 'Save') }}
          </Btn>
        </div>

        <Panel
          v-if="match.id"
          class="p-0 position-relative mx-n3"
          :variant="[
            'transparent',
            'stroked',
            'stroked-secondary',
            'rounded',
            'rounded-medium',
          ]"
        >
          <PlayersTable
            :players="match.players || []"
            :can-edit="isEdit"
            :can-edit-players="canDeletePlayers"
            :is-loading="isLoading"
            :edit-results-data="editResultsData"
            :ignore-scores="ignoreScores"
            @userMenuOpen="$listeners.userMenuOpen"
            @addPlayer="$listeners.addPlayer"
            @openChat="startOneToOneChat"
            @deletePlayer="onDeletePlayer"
            @toggleEqualsRanks="hasEqualsRanks = $event"
          />
        </Panel>
        <HeraDummyList v-else position="center">
          <Loader />
        </HeraDummyList>
      </div>
    </Panel>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Panel from '@/components/atoms/Panel';
import dateMethods from '@/mixins/dateMethods';
import { prop, propRequired } from '@/utils/factories';
import { translate } from '@/mixins/translate';
import { BATTLE_STATUSES as STATUSES } from '@/constants/battles';
// import DateTimePicker from '@/components/form/DateTimePicker';
import Icon from '@/components/atoms/Icon';
import ToolIcon from '@/views/tournaments/management/brackets/components/ToolIcon';
import Subheader from '@/components/nuclides/Subheader';
import PlayersTable from './PlayersTable';
import StatusLabel from '@/components/molecules/StatusLabel';
import TextBlock from '@/components/atoms/TextBlock';
import HeraDummyList from '@/components/common/HeraDummyList';
import Loader from '@/components/common/Loader';
import Btn from '@/components/atoms/HeraFormBtn';

import { CLAN } from '@/constants/accounts';

export default {
  name: 'PlayoffMatchCardBR',
  components: {
    TextBlock,
    Btn,
    Loader,
    HeraDummyList,
    Subheader,
    ToolIcon,
    Icon,
    PlayersTable,
    Panel,
    StatusLabel,
  },
  mixins: [
    ...dateMethods,
    translate('_web_tournament-grid_battle-royale_card'),
  ],
  props: {
    roundIndex: propRequired(Number),
    roundName: prop(String),
    matchIndex: propRequired(Number),
    canChangeMatchDate: prop(Boolean),
    canChangeMatchDuration: prop(Boolean),
    canDeletePlayers: prop(Boolean),
    nextRoundStart: prop(),
    prevRoundEnd: propRequired(),
    isLoading: prop(Boolean),
    isEdit: prop(Boolean),
    editResultsData: prop(Object, null),
    matchActions: prop(Array),
    match: {
      type: Object,
      default: () => ({
        id: '',
        index: 0,
        next_match_id: '',
        next_match_index: 0,
        players: [],
        round: 0,
      }),
    },
  },
  data() {
    return {
      uniqueId: this.$lodash.uniqueId('v_datetime'),
      hasEqualsRanks: false,
    };
  },
  computed: {
    ...mapGetters(['isRTL']),
    scheduleAction() {
      return this.matchActions.find(item => item.key === 'schedule-match');
    },
    filteredMatchAction() {
      return this.matchActions.filter(item => item.key !== 'schedule-match');
    },
    ignoreScores() {
      return ![
        STATUSES.started,
        STATUSES.completed,
        STATUSES.cancelled,
        STATUSES.judging,
      ].includes(this.match.status);
    },
  },
  // watch: {
  //   isSwapping: function(newVal) {
  //     if (!newVal) {
  //       this.afterSwap();
  //     }
  //   },
  // },
  methods: {
    ...mapActions(['startTournamentChat']),
    onDeletePlayer(payload = {}) {
      this.$emit('playerDeleted', { matchID: this.match.id, ...payload });
    },
    startOneToOneChat({ id, login, type }) {
      this.startTournamentChat({ id: type === CLAN ? id : login }).catch(
        this.errorNotify
      );
    },
  },
};
</script>

<style lang="scss">
.playerTournamentBracket {
  .tournament-grid-players-table th:last-child,
  .tournament-grid-players-table td:last-child,
  .actions {
    display: none !important;
  }
  .ph-panel.ph-panel--default {
    background-color: var(--ph-input-bg) !important;
  }
  .tournament-grid-players-table .hera-table .thead-main {
    background-color: transparent !important;
  }
}

.match-br-wrapper {
  --round-height: 36rem;
  min-height: var(--round-height);
  height: auto !important;
  transition: all 0.2s ease-in;
  .match-card {
    z-index: 1;
    min-width: calc(500px - 2rem);
    top: 0;
    transition: border-color 0.2s, width 0.2s, height 0.2s;
    .status-label {
      max-width: 90px;
      text-align: center;
      justify-content: center;
    }
    .mx-input {
      font-size: 0.875rem !important;
    }
    .tournament-grid-players-table {
      td,
      th {
        &:first-of-type {
          padding-left: 1.5rem !important;
        }
        &:last-of-type {
          padding-right: 1.5rem !important;
        }
      }
      th .playhera-label {
        text-transform: capitalize;
        font-size: 14px !important;
      }
      .sort-table {
        tbody tr:nth-child(odd) {
          background: none;
        }
      }
      // height: calc(var(--round-height) - 8rem);
      // padding-right: 1.5rem;
      // .thead-main {
      //   right: 1.75rem; // 1.5rem + 8px/2 border-spacing
      // }
    }
    .list-item-title {
      max-width: 5rem;
    }
  }
  .edit-controller-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // todo please replace it.
    // template
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(28, 28, 36, 0.85) 15%,
      #1c1c24 100%
    );
  }
}
</style>
